import { z } from 'zod';

import { SiteOperationalPhaseSchema } from '@/api/fe-api/domain/entities/site-operational-phase';

export const formUpdateSchema = z.object({
  picture: z.instanceof(File).optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  address: z.string().optional(),
  installationDate: z.date().optional(),
  commissioningDate: z.date().optional(),
  operationalPhase: SiteOperationalPhaseSchema.optional(),
  nominalPowerHumanReadable: z.number().optional(),
  nominalEnergyHumanReadable: z.number().optional(),
});

export type FormUpdateInputs = z.infer<typeof formUpdateSchema>;
